import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: '/images/banners/freepik__the-style-is-candid-image-photography-with-natural__13648.webp',
      title: 'Transform Your Celebrations',
      subtitle: 'Creating Magical Moments with Premium Decorations'
    },
    {
      image: '/images/banners/freepik__the-style-is-candid-image-photography-with-natural__24137.webp',
      title: 'Elegant Decorations for Every Occasion',
      subtitle: 'Making Your Special Days Unforgettable'
    },
    {
      image: '/images/banners/freepik__the-style-is-candid-image-photography-with-natural__3442.webp',
      title: 'Premium Quality, Exceptional Service',
      subtitle: 'Trusted by Thousands of Happy Customers'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section id="home" className="hero">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          >
            <img src={slide.image} alt={slide.title} />
            <div className="hero-overlay"></div>
            <div className="hero-content">
              <h2 className="hero-title">{slide.title}</h2>
              <p className="hero-subtitle">{slide.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="hero-indicators">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default Hero;
